import { ReactElement, useCallback, useEffect, useState } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { useLoadingState } from '../../../../hooks/useLoadingState';
import { getBaseInformation } from '../requests';
import { BaseInformation } from '../types';

export interface BaseLoaderProps {
  offerId: number | string;
  children: (props: BaseInformation) => ReactElement;
}

export default function BaseLoader({ offerId, children }: BaseLoaderProps) {
  const { loading, setLoading } = useLoadingState();
  const [data, setData] = useState<BaseInformation>();
  const [error, setError] = useState<AxiosResultDefaultError>();

  /* Función que se llama cuando se monta el componente. Trae la info utilizada en la vista */
  const load = useCallback(async () => {
    setLoading(true);

    const response = await getBaseInformation(offerId);

    if (response.data) {
      setData(response.data);
      setError(undefined);
    }
    if (response.error) {
      setError(response.error);
    }
    setLoading(false);
  }, [offerId, setLoading]);

  useEffect(() => {
    load();
  }, [load]);

  if (error) {
    return (
      <DisplayError
        typeError={error.code}
        retryAction={load}
        loadingAction={loading}
      />
    );
  }

  if (loading) {
    return <Loading />;
  }

  if (!data) {
    return (
      <DisplayError
        typeError="Data no cargada"
        retryAction={load}
        loadingAction={loading}
      />
    );
  }

  return children(data);
}
